import type { TFunction } from 'i18next';
import type { TourStep } from '../components/common/SystemTour';

/** localStorage: 「次回以降は表示しない」または旧完了フラグ */
export const SAMPLE_MANAGER_TOUR_STORAGE_KEY = 'sample-manager-tour-completed';
/** 旧キー互換（同一値） */
const LEGACY_TOUR_KEYS = ['sample-manager-tour-completed', 'sample-manager-tour-hide'] as const;

export function isSampleManagerTourHidden(): boolean {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    return LEGACY_TOUR_KEYS.some((k) => localStorage.getItem(k) === 'true');
  } catch {
    return false;
  }
}

/** ヘルプからツアーをやり直すとき */
export function clearSampleManagerTourHidden(): void {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    for (const k of LEGACY_TOUR_KEYS) {
      localStorage.removeItem(k);
    }
  } catch {
    // ignore
  }
}

function asFeatureList(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((x): x is string => typeof x === 'string') : [];
}

const TOUR_STEP_KEYS = [
  'welcome',
  'modes',
  'registration',
  'usage_records',
  'management',
  'explore',
] as const;

/** SystemTour 用ステップ（i18n から組み立て） */
export function buildSampleManagerTourSteps(t: TFunction): TourStep[] {
  return TOUR_STEP_KEYS.map((key) => ({
    title: t(`sample.tour.${key}.title`),
    description: t(`sample.tour.${key}.description`),
    features: asFeatureList(t(`sample.tour.${key}.features`, { returnObjects: true })),
  }));
}
